
export enum MaxAllowedSocDateActionDispatchTypes {
  GET_MAX_ALLOWED_SOC_DATE_INVOKE = "GET_MAX_ALLOWED_SOC_DATE_INVOKE",
  GET_MAX_ALLOWED_SOC_DATE_SUCCESS = "GET_MAX_ALLOWED_SOC_DATE_SUCCESS",
  GET_MAX_ALLOWED_SOC_DATE_ERROR = "GET_MAX_ALLOWED_SOC_DATE_ERROR",
  GET_MAX_ALLOWED_SOC_DATE_RESET = "GET_MAX_ALLOWED_SOC_DATE_RESET",
}
